import _classCallCheck from "/Users/macmini/Documents/Work/Coding/2021/Olga Ribler/das-ohr-landing/das-ohr-landing/node_modules/@babel/runtime/helpers/esm/classCallCheck";
export var EmailJSResponseStatus = function EmailJSResponseStatus(httpResponse) {
  _classCallCheck(this, EmailJSResponseStatus);

  this.status = httpResponse.status;
  this.text = httpResponse.responseText;
};